"use client"

import { richTextRender } from '@lib/rich-text-base'
import type { TypeVideoPlayerFields } from '@lib/generated-types'
import type { ComponentPropsWithoutRef } from 'react'
import { VideoPlayer as Block } from '@shc/ui'
import { startYouTubeTracking } from '@snowplow/browser-plugin-youtube-tracking'
import { getYoutubeVideoIdFromUrl } from '@lib/utilities/video-utilities'
interface VideoPlayerBlockProps extends ComponentPropsWithoutRef<'div'>, TypeVideoPlayerFields {
  showCaption: boolean
  videoUrl?: string
  autoPlay?: boolean
  loop?: boolean
}

const VideoPlayerBlock = ({
  videoUrl,
  caption,
  showCaption = true,
  autoPlay = false,
  loop = false,
}: VideoPlayerBlockProps) => {

  const videoId = getYoutubeVideoIdFromUrl(videoUrl)

  return (
    <Block
      iframeId={videoId}
      id={videoId}
      description={showCaption && caption && richTextRender(caption)}
      url={videoUrl}
      autoPlay={autoPlay}
      loop={loop}
      onReady={() => {
        if (videoId) {
          startYouTubeTracking({
            id: videoId,
            video: videoId,
            captureEvents: ['play', 'pause', 'end', 'percent_progress', 'error'],
          })
        } else {
          console.error('Cannot find YouTube video ID to track analytics')
        }
      }}      
    />
  )
}

export default VideoPlayerBlock
